import {Decoder, field, nullable, number, object, string} from 'json-bouncer'
import {LocalDateTime} from 'js-joda'
import {localDateTimeDecoder} from '../Data/DecodeHelper'
import {
    InquiryProofCopyStatus,
    proofCopyStatusDecoder
} from './InquiryProofCopyStatus'
import {InquiryOfferStatus, offerStatusDecoder} from './InquiryOfferStatus'

export interface Inquiry {
    readonly id: number
    readonly inquiryNumber: number
    readonly offerStatus: InquiryOfferStatus
    readonly proofCopyStatus: InquiryProofCopyStatus
    readonly offerName1: string
    readonly offerName2: string
    readonly offerName3: string
    readonly offerName4: string
    readonly offerStreet: string
    readonly offerHouseNumber: string
    readonly offerZipCode: string
    readonly offerCity: string
    readonly offerCountry: string
    readonly invoiceName1: string
    readonly invoiceName2: string
    readonly invoiceName3: string
    readonly invoiceName4: string
    readonly invoiceStreet: string
    readonly invoiceHouseNumber: string
    readonly invoiceZipCode: string
    readonly invoiceCity: string
    readonly invoiceCountry: string
    readonly deliveryName1: string
    readonly deliveryName2: string
    readonly deliveryName3: string
    readonly deliveryName4: string
    readonly deliveryFloor: string
    readonly deliveryRoom: string
    readonly deliveryStreet: string
    readonly deliveryHouseNumber: string
    readonly deliveryZipCode: string
    readonly deliveryCity: string
    readonly deliveryCountry: string
    readonly shippingMethod: string
    readonly netShippingCosts: number | null
    readonly grossShippingCosts: number | null
    readonly vatId: string
    readonly companyId: number
    readonly transactionNumber: string
    readonly customerId: number
    readonly manufacturerId: number
    readonly notes: string
    readonly created: LocalDateTime
    readonly updated: LocalDateTime
}

export function inquiryDecoder(): Decoder<Inquiry> {
    return object({
        id: field('id', number()),
        inquiryNumber: field('inquiryNumber', number()),
        offerStatus: field('offerStatus', offerStatusDecoder()),
        proofCopyStatus: field('proofCopyStatus', proofCopyStatusDecoder()),
        offerName1: field('offerName1', string()),
        offerName2: field('offerName2', string()),
        offerName3: field('offerName3', string()),
        offerName4: field('offerName4', string()),
        offerStreet: field('offerStreet', string()),
        offerHouseNumber: field('offerHouseNumber', string()),
        offerZipCode: field('offerZipCode', string()),
        offerCity: field('offerCity', string()),
        offerCountry: field('offerCountry', string()), 
        invoiceName1: field('invoiceName1', string()),
        invoiceName2: field('invoiceName2', string()),
        invoiceName3: field('invoiceName3', string()),
        invoiceName4: field('invoiceName4', string()),
        invoiceStreet: field('invoiceStreet', string()),
        invoiceHouseNumber: field('invoiceHouseNumber', string()),
        invoiceZipCode: field('invoiceZipCode', string()),
        invoiceCity: field('invoiceCity', string()),
        invoiceCountry: field('invoiceCountry', string()),
        deliveryName1: field('deliveryName1', string()),
        deliveryName2: field('deliveryName2', string()),
        deliveryName3: field('deliveryName3', string()),
        deliveryName4: field('deliveryName4', string()),
        deliveryFloor: field('deliveryFloor', string()),
        deliveryRoom: field('deliveryRoom', string()),
        deliveryStreet: field('deliveryStreet', string()),
        deliveryHouseNumber: field('deliveryHouseNumber', string()),
        deliveryZipCode: field('deliveryZipCode', string()),
        deliveryCity: field('deliveryCity', string()),
        deliveryCountry: field('deliveryCountry', string()),
        shippingMethod: field('shippingMethod', string()),
        netShippingCosts: field('netShippingCosts', nullable(number())),
        grossShippingCosts: field('grossShippingCosts', nullable(number())),
        vatId: field('vatId', string()),
        companyId: field('companyId', number()),
        transactionNumber: field('transactionNumber', string()),
        customerId: field('customerId', number()),
        manufacturerId: field('manufacturerId', number()),
        notes: field('notes', string()),
        created: field('created', localDateTimeDecoder()),
        updated: field('updated', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Inquiry.ts